const getDefaultState = () => {
  return {
    searchQuestions: {
      data: [],
      count: 0
    },
    isFetchingQuestion:false
  };
};

const state = getDefaultState();

const getters = {
  getSearchQuestions: state => state.searchQuestions,
  isFetchingQuestion : state => state.isFetchingQuestion
};

const mutations = {

  setIsFetchingData : (state,{data})=>{
    state.isFetchingQuestion = data
  },

  setSearchQuestions: (state, data) => {
    
    state.searchQuestions.data = data ? data.data : [] ;
    state.searchQuestions.count = data.pagination ? data.pagination.total_count : {} ;
  },

  appendSearchQuestions: (state, data) => {
    state.searchQuestions.data.push(...data.data);
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  resetQAState({ commit }) {
    commit("resetState");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/QA.js